<template>
    <div>
        <div class="h-100">
            <div style="display: flex;justify-content: space-between;">
                <h4 class="modal-title mt-2 ml-3" style="color: #b5b5b5">{{$t('Dashboard')}}</h4>
                <div v-if="installedDashboardPluginsArray.length" class="primary-btn-style justify-content-end">
                    <button class="btn btn-outline-secondary m-1" v-on:click="clickToOpenWidgetStore()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16" style="position:relative;bottom: 2px;">
                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                        </svg>
                    {{$t('Add widgets')}}</button>
                </div>
            </div>
            <div class="widget-wrapper">
                <template v-if="installedDashboardPluginsArray.length">
                    <template v-for="widget,index in installedDashboardPluginsArray">
                        <div :key="widget._id" v-if="!loadTypeCheck(widget)" class="widget-styles jobs-widget-styles" style="height:380px;background: #1a1e21;">
                            <div class="nav-item dropdown show" style="inset-inline-end :0%;top: 8px;position:absolute">
                                <a class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#717171" class="bi bi-three-dots icon-on-hover-styles" viewBox="0 0 16 16">
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                </svg>
                                </a>
                                <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                    <a class="dropdown-item p-2" v-on:click="removeWidget(widget._id)">
                                        <span>{{$t('Remove Widget')}}</span></a>
                                </div>
                            </div>
                            <jobs-widget v-if="widget.name == 'Jobs'"></jobs-widget>
                            <bins-monitor-widget v-if="widget.name == 'Bins Monitor'"></bins-monitor-widget>
                        </div> 
                        <div :key="widget._id" v-if="loadTypeCheck(widget) == 'plugin'" class="widget-styles" :style="checkEmptyCellsToFit(widget,index)">
                            <div style="position:absolute;display:flex;inset-inline-end:0px">
                                <!-- <div v-if="showRefreshIcon(widget.name)"> //For OLDER approach
                                    <svg v-on:click="refreshTheWidget(widget)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#717171" class="bi bi-arrow-clockwise icon-on-hover-styles" viewBox="0 0 16 16" style="top: 8px;position: relative;">
                                        <title>{{$t('Refresh')}}</title>
                                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                    </svg>
                                </div> -->
                                <!-- <div> //For OLDER approach
                                    <a class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#717171" class="bi bi-three-dots icon-on-hover-styles" viewBox="0 0 16 16">
                                        <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                    </svg>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions-1">
                                    <a v-if="omitEditButton(widget.name)" class="dropdown-item p-2" v-on:click="editWidget(widget)">
                                        <span>{{$t('Edit Widget')}}</span></a>
                                    <a class="dropdown-item p-2" v-on:click="removeWidget(widget._id)">
                                        <span>{{$t('Remove Widget')}}</span></a>
                                    </div>
                                </div> -->
                            </div>
                             <!--For newer approach below code-->
                            <component 
                            :is="checkIsWidgetAddedAndGetHTML(widget)" 
                            :widgetDataFromParent="widget" 
                            :installedDashboardPluginsArray="installedDashboardPluginsArray"
                            @addWidgetFromChild="addWidgetFromChild"
                            @reloadWidget="reloadWidget"
                            @removeSelectedWidget="removeWidget"
                            :ref="(el) => setComponentRef(el,widget._id)"
                            ></component>
                            <!-- <iframe :id="getIdOfIframe(widget)" style="width:100%;height:100%;" frameBorder=0></iframe>  //For OLDER approach --> 
                        </div>
                    </template> 
                </template>
                <template v-else>
                    <div class="outer">
                        <div class="middle">
                            <div class="inner">
                                <p>{{$t('No widgets are added')}}</p>
                                <div class="primary-btn-style justify-content-end">
                                    <button class="btn btn-outline-secondary m-1" v-on:click="clickToOpenWidgetStore()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16" style="position:relative;bottom: 2px;">
                                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                        </svg>
                                    {{$t('Add widgets')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <dashboard-plugin-store v-if="openDashboardWidgetStore" @addWidgetToDashboard='addWidgetToDashboard' @close="closeDashboardWidgetStore"></dashboard-plugin-store>
        <job-details-modal v-if="openJobDetails" :jobId="selectedJobId" @close="closeModal"></job-details-modal>
    </div>
</template>

<script>

import WidgetStore from "./DashboardWidgetStore.vue";
import jobsWidget from "../jobs/JobsDashboardWidget.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {dashboardWidgets} from "../../registry/plugins.js"
import Constants from "../../components.constants.js"
// import {NotifierConstants} from "../../components.constants.js";
import jobDetailsModal from "../jobs/JobDetails.vue";
import binsMonitorWidget from "./BinsMonitorWidget.vue";
import Utils from "../../components.utils.js" //For newer approach

export default ({
    data(){
        return{
            installedDashboardPluginsArray:[],
            openDashboardWidgetStore:false,
            registeredWidgetsData:[],
            mapWidgetDataWithPlugin:{},
            selectedComponent: null,
            requiredPropsToNavigate: null,
            openJobDetails:false,
            selectedJobId:null,
            widgetsList:[],
            addWidget:null,
            removeWidgetInfo:null,
            componentRefs:{},
        }
    },
    methods:{
        setComponentRef(comp,id){
            if(id && comp && comp.$el){
                this.$nextTick(()=>{
                    this.componentRefs[id] = comp;
                    //this.$refs[id] = comp.$el;
                });
            }
        },
        clickToOpenWidgetStore(){
            this.openDashboardWidgetStore = true;
        },
        closeDashboardWidgetStore(){
            this.openDashboardWidgetStore = false;
        },
        addWidgetToDashboard(newWidget){
            this.installedDashboardPluginsArray.push(newWidget);
            this.registerInstalledWidgets();
        },
        isEnabled(priv) {
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
        },
        getDashboardData(){
            this.getInstalledWidgetsOfUserFromServer().then((data) => {
                if(data.my_dashboard){
                    this.installedDashboardPluginsArray = data["my_dashboard"];
                    for(let i = 0; i< this.installedDashboardPluginsArray.length; i++){
                        this.installedDashboardPluginsArray[i]['UUID'] = Utils.getUUID();
                    }
                }
            });
        },
        loadTypeCheck(data){
            let index = this.registeredWidgetsData.findIndex(e => e.widgetName == data.name);
            if(this.registeredWidgetsData[index])
            return this.registeredWidgetsData[index].loadType;
        },
        registerInstalledWidgets() {
          for(let widget of this.installedDashboardPluginsArray){
            if (widget.name == "Jobs"){
              let jobs = new dashboardWidgets("Jobs","Jobs","core")
              jobs.register()
            }
            if (widget.name == "Bins Monitor"){
              let jobs = new dashboardWidgets("Bins Monitor","Bins Monitor","core")
              jobs.register()
            }
          }
        },
        omitEditButton(name){
            let namesArray = ['Tickets','Jobs','My Tickets List','Bins Monitor','Server Monitor'];
            if(namesArray.includes(name)){
                return false;
            }
            return true;
        },
        showRefreshIcon(name){
            let namesArray = ['Workflows'];
            if(!(namesArray.includes(name))){
                return false;
            }
            return true;
        },
        addWidgetFromChild(payload){
            //this.reloadWidgetFromParent = false;
            this.updateWidgetWithProjectId(payload).then((data) => {
            if (Constants.acceptedStatusCodes.includes(data.statusCode)) {
                    if(data.message){
                        this.$toast.success(data.message);
                    }else{
                        this.$toast.success("Updated successfully");
                    }
                    //this.reloadWidgetFromParent = true;
                    if(this.componentRefs[payload._id] && typeof this.componentRefs[payload._id].loadWidgetData == 'function'){
                         this.componentRefs[payload._id].loadWidgetData();
                    }else{
                         this.componentRefs[payload._id].reload();
                    }
                } else {
                    if(data.message){
                        console.log("Failed")
                        this.$toast.error(data.message);
                    }else{
                        this.$toast.error("Failed");
                    }
                   // this.reloadWidgetFromParent = false;
                }
            })
        },
        reloadWidget(widgetInfo){
            this.checkIsWidgetAddedAndGetHTML(widgetInfo)
        },
        /*
        checkIsWidgetAddedAndGetHTML(widget,onUpdate = false,forceUpdate=false){ //For OLDER approach
            let index = this.registeredWidgetsData.findIndex(e => e.widgetName == widget.name);
            if(index >= 0){
                let registeredData = this.registeredWidgetsData[index]
                if(registeredData.loadType == 'plugin'){
                    if(!registeredData){
                        return false
                    }
                    this.loadDashboardWidgetsFromExternalPlugin({id: registeredData.id,widgetName: widget.name,tagId: widget._id, widgetId: widget._id + this.getWidgetName(widget.name),forceUpdate:forceUpdate})// eslint-disable-line no-undef
                    this.listenMessageToLoadData(widget,onUpdate)
                    return 'plugin';
                }else{
                    return 'core';
                }
            }else{
                return false;
            }
        },
        */
        checkIsWidgetAddedAndGetHTML(widget){ //For newer approach
            widget['UUID'] = Utils.getUUID();
            let index = this.registeredWidgetsData.findIndex(e => e.widgetName == widget.name);
            if(index >= 0){
                let pluginInfo = this.registeredWidgetsData[index];
                if(pluginInfo && Object.prototype.hasOwnProperty.call(pluginInfo, 'registrationType') && pluginInfo.registrationType == 'dashboardWidgets'){
                    let comp = null;
                    if(Object.prototype.hasOwnProperty.call(pluginInfo, 'renderComponent')){
                        comp = pluginInfo.component[pluginInfo.renderComponent];
                    }else{
                        comp = pluginInfo.component;
                    }
                    return comp;
                }else{
                    return 'core';
                }
            }else{
                return false;
            }
        },
        getIdOfIframe(data){
            return data._id + this.getWidgetName(data.name);
        },
        getWidgetName(name){
            return '_'+name.toString().replace(/\s/g,'')
        },
        checkEmptyCellsToFit(data){
            let index = this.registeredWidgetsData.findIndex(e => e.widgetName == data.name);
            if(index > -1 && this.registeredWidgetsData[index]){
                if(this.registeredWidgetsData[index].styles && Object.keys(this.registeredWidgetsData[index].styles).includes("grid-column")){
                    return this.registeredWidgetsData[index].styles;
                }
            }
        },
        removeWidget(id){
            let payload = {params:id};
            this.deleteWidget(payload).then((data) => {
                if (Constants.acceptedStatusCodes.includes(data.statusCode)) {
                    if(data.message){
                        this.$toast.success(data.message);
                    }else{
                        this.$toast.success("Deleted successfully");
                    }
                    this.installedDashboardPluginsArray = this.installedDashboardPluginsArray.filter(e => e._id != id)
                } else {
                    this.$toast.error("Failed");
                }
            })
        },
        editWidget(data){
            this.editWidgetData = data; //For newer approach
            /* let temp = this.getIdOfIframe(data); //For OLDER approach
            document.getElementById(temp).contentWindow.postMessage({
                cmd: 'message',
                params: {
                    widgetData:data,
                    editWidget:true
                }
            }, '*') */
        },
        redirectToRespectivePage(item,wInfo){
            if(wInfo.name == "Workflows"){
                this.openJobDetails = true;
                this.selectedJobId = item.job_id;
            }else{
                this.$router.push({
                    name: this.getRouterNameType(wInfo),
                    params:this.getRouteParams(item, wInfo),
                    query:this.getRouteQueries(item, wInfo),
                });
            }
        },
        closeModal() {
            this.openJobDetails = false;
            this.selectedJobId = null;
        },
        getRouterNameType(wInfo){
            if(wInfo.name == "My Tasks List"){
                return 'tasks-window'
            }else if(wInfo.name == "My Issues List"){
                return 'tasks-window';
            }else if(wInfo.name == "Tasks"){
                return 'tasks-projects';
            }else if(wInfo.name == "Issues"){
                return 'issues-projects';
            }else if(wInfo.name == "Tickets"){
                return 'ticket-display';
            }else if(wInfo.name == "My Tickets List"){
                return 'tasks-window';
            }else if(wInfo.name == "Media Pipeline Stage Assets"){
                return 'pipeline-report';
            }else{
                return false;
            }
        },
        getRouteParams(item, wInfo){
            if(wInfo.name == "My Tasks List"){
                return {taskId: item.task_tag, tabType:'de', subComp:'tasks-window', parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(wInfo.name == "My Issues List"){
                return {taskId: item.task_tag, tabType:'de', subComp:'tasks-window', parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(wInfo.name == "Tasks"){
                return {projectId: wInfo.project_id,subComp:'tasks-projects',parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }if(wInfo.name == "Issues"){
                return {projectId: wInfo.project_id,subComp:'issues-projects',parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(wInfo.name == "Tickets"){
                return {parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(wInfo.name == "My Tickets List"){
                return {taskId: item.task_tag,  tabType:'de', subComp:'tasks-window', parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else if(wInfo.name == "Media Pipeline Stage Assets"){
                return {stageId: item.stage_id, fromDashboard:true, subComp:'pipeline-report', parentinfo:Object.assign({forceRedirect:true},this.$route)}
            }else{
                return false;
            }
        },
        getRouteQueries(item,wInfo){
            if(wInfo.name == "Tasks" || wInfo.name == "Issues"){
                if(item == 'all-new'){
                    return {status_type: 'New', project_id:wInfo.project_id}
                }else if(item == 'all-inprogress'){
                    return {status_type: 'In Progress', project_id:wInfo.project_id}
                }else if(item == 'my-new'){
                    return {status_type: 'New',users: JSON.stringify([wInfo.user_id]), project_id:wInfo.project_id}
                }else if(item == 'my-inprogress'){
                    return {status_type: 'In Progress',users: JSON.stringify([wInfo.user_id]), project_id:wInfo.project_id}
                }
            }else if(wInfo.name == "Tickets"){
                if(item == 'all-new'){
                    return {status_type: 'New'}
                }else if(item == 'all-inprogress'){
                    return {status_type: 'In Progress'}
                }else if(item == 'my-new'){
                    return {status_type: 'New',users: JSON.stringify([wInfo.user_id])}
                }else if(item == 'my-inprogress'){
                    return {status_type: 'In Progress',users: JSON.stringify([wInfo.user_id])}
                }
            }else if(wInfo.name == "My Tasks List"){
                return {editMode:true, taskContext:'Task'}
            }else if(wInfo.name == "My Issues List"){
                return {editMode:true, taskContext:'Issue'}
            }else if(wInfo.name == "My Tickets List"){
                return {editMode:true, taskContext:'Ticket'}
            }else{
                return false;
            }
        },

        refreshTheWidget(widget){
            /*let id = widget._id + this.getWidgetName(widget.name) //For OLDER approach
                if(document.getElementById(id))this.iframeController = document.getElementById(id).contentWindow;
                    this.iframeController.postMessage({
                        cmd: 'message',
                        params: {
                            widgetData:widget,
                            refreshWidget:true
                        }
                }, '*') */
            this.checkIsWidgetAddedAndGetHTML(widget); //For newer approach
        },

        listenMessageToLoadData(widget,onUpdate){
            window.addEventListener('message', (event)=>{
                let cmd = event.data.cmd;
                switch (cmd) {
                case 'readyToListenMessage':{
                    if(widget){
                        let id = widget._id + this.getWidgetName(widget.name);
                        if(document.getElementById(id))this.iframeController = document.getElementById(id).contentWindow;
                        if(onUpdate){
                            this.iframeController.postMessage({
                                cmd: 'message',
                                params: {
                                    widgetData:widget,
                                    updateWidget:true
                                }
                            }, '*')
                        }else{
                            this.iframeController.postMessage({
                            cmd: 'message',
                            params: {
                                widgetData:widget,
                                addWidget:true,
                            }
                        }, '*')
                        }
                    }
                    break;
                }
                case 'readyToListenStartUpDataMessage':{
                    if(widget){
                        let id = widget._id + this.getWidgetName(widget.name);
                        if(document.getElementById(id))this.iframeController = document.getElementById(id).contentWindow;
                        this.iframeController.postMessage({
                                cmd: 'startUpMessage',
                                params: {
                                    startUpData:this.getStartUpDataFromInCache,
                                }
                        }, '*')
                    }
                    break;
                }
            }   
            });
        },

        manageDashboardWidgetsFunctionality(event){
            let cmd = event.data.cmd;
            switch (cmd) {
              case 'createWidgetOnSelectedProject':{
                    if(event.data.params.saveChanges && event.data.params.selectedProject){
                        let payload = {};
                        if(Object.keys(event.data.params.selectedProject).includes("workflow_id")){
                            payload = {_id:event.data.params.saveChanges._id,"project_id":event.data.params.selectedProject.workflow_id,"project_name":event.data.params.selectedProject.workflow_name};
                        }else if(Object.keys(event.data.params.selectedProject).includes("pipeline_name")){
                            if(event.data.params.stage_info && event.data.params.stage_info.stage_id){
                                payload = {_id:event.data.params.saveChanges._id,"project_id":event.data.params.selectedProject.project_id?event.data.params.selectedProject.project_id:event.data.params.selectedProject._id,"stage_id":event.data.params.stage_info.stage_id};
                            }else{
                                payload = {_id:event.data.params.saveChanges._id,"project_id":event.data.params.selectedProject.project_id?event.data.params.selectedProject.project_id:event.data.params.selectedProject._id,"project_name":event.data.params.selectedProject.pipeline_name,"pipeline_name":event.data.params.selectedProject.pipeline_name};
                            }
                        }else{
                            payload = {_id:event.data.params.saveChanges._id,"project_id":event.data.params.selectedProject._id,"project_name":event.data.params.selectedProject.project_name};
                        }
                        this.updateWidgetWithProjectId(payload).then((data) => {
                        if (Constants.acceptedStatusCodes.includes(data.statusCode)) {
                                if(data.message){
                                    this.$toast.success(data.message);
                                }else{
                                    this.$toast.success("Updated successfully");
                                }
                                let index = this.installedDashboardPluginsArray.findIndex(e => e._id == event.data.params.saveChanges._id);
                                if(index > -1){
                                    if(Object.keys(event.data.params.selectedProject).includes("workflow_id")){
                                        this.installedDashboardPluginsArray[index]["project_id"] = event.data.params.selectedProject.workflow_id;
                                        this.installedDashboardPluginsArray[index]["project_name"] = event.data.params.selectedProject.workflow_name;
                                    }else if(Object.keys(event.data.params.selectedProject).includes("pipeline_name")){
                                            this.installedDashboardPluginsArray[index]["project_id"] = event.data.params.selectedProject.project_id?event.data.params.selectedProject.project_id:event.data.params.selectedProject._id;
                                            this.installedDashboardPluginsArray[index]["project_name"] = event.data.params.selectedProject.pipeline_name;
                                            this.installedDashboardPluginsArray[index]["pipeline_name"] = event.data.params.selectedProject.pipeline_name;
                                            if(event.data.params.stage_info && event.data.params.stage_info.stage_id){
                                                this.installedDashboardPluginsArray[index]["stage_id"] = event.data.params.stage_info.stage_id;
                                            }
                                    }else{
                                        this.installedDashboardPluginsArray[index]["project_id"] = event.data.params.selectedProject._id;
                                        this.installedDashboardPluginsArray[index]["project_name"] = event.data.params.selectedProject.project_name;   
                                    }
                                    this.checkIsWidgetAddedAndGetHTML(this.installedDashboardPluginsArray[index],true,true)
                                }
                            } else {
                                if(data.message){
                                    console.log("Failed")
                                    // this.$toast.error(data.message);
                                }else{
                                    this.$toast.success("Failed");
                                }
                            }
                        })
                    }
                    break;
                }

                case 'cancelProjectSelection':{
                        if(event.data.params.cancelSave){
                            this.removeWidget(event.data.params.cancelSave._id);
                        }
                    break;
                }

                case 'navigate':{
                        if(event.data.params.navigateData && event.data.params.widgetInfo){
                            let tempNavigationData = event.data.params.navigateData;
                            let tempWidgetInfo = event.data.params.widgetInfo;
                            if(event.data.params.navigateToStage){
                                this.$router.push({
                                    name: 'media-pipeline-stage',
                                    query: {'id':event.data.params.navigateData.stage_id},
                                    params: {'fromDashboard':true}
                                });
                            }else{
                                this.redirectToRespectivePage(tempNavigationData,tempWidgetInfo)
                            }
                        }
                    break;
                }

                case 'doNothing':{
                        if(event.data.params.widgetInfo){
                            this.checkIsWidgetAddedAndGetHTML(event.data.params.widgetInfo,false,true)
                        }
                    break;
                }

              default:
                break;
            }
        },
        sendNotificationToChild(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let matchedArr = this.installedDashboardPluginsArray.filter(e => e.name == 'Workflows');
            if(matchedArr.length > 0){
                for(let i = 0;i < matchedArr.length; i++){
                    let temp = this.getIdOfIframe(matchedArr[i]);
                    let workflowWidgetInfo = JSON.parse(JSON.stringify(matchedArr[i]));
                        document.getElementById(temp).contentWindow.postMessage({
                            cmd: 'message',
                            params: {
                                widgetData:workflowWidgetInfo,
                                isNotification:true,
                                notificationData:notification
                            }
                    }, '*')
                }
            }
        },
        listenMessagesFromChild(){
          window.addEventListener('message', this.manageDashboardWidgetsFunctionality)
        },
        ...mapMutations("registry",["loadDashboardWidgetsFromExternalPlugin"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("dashboard", ["getInstalledWidgetsOfUserFromServer","addToDashboard","updateWidgetWithProjectId","deleteWidget"]),
    },
    computed:{
        currentProperties(){
            return this.requiredPropsToNavigate;
        },
        ...mapGetters("users", ["getIsMetadataDockVisible","getIsAssetsDetailsPanelVisible","getLoggedInUserAccessControl","getLoggedInUserPrivilege"]),
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapGetters("registry",["getRegisteredDashboardWidgets", "getDashboardWidgetsPlugins"]),
        ...mapGetters("pluginRepo",["getInstalledPluginsData"]),
    },
    components:{
        "dashboard-plugin-store":WidgetStore,
        "jobs-widget":jobsWidget,
        "job-details-modal":jobDetailsModal,
        "bins-monitor-widget":binsMonitorWidget,
    },
    watch:{
        getDashboardWidgetsPlugins:{
                    deep:true,
                    immediate:true,
                    async handler(newVal,oldVal){
                    if(newVal && oldVal){
                        try{ //For newer approach
                            for(let i = 0; i < this.getDashboardWidgetsPlugins.length; i++){
                                  let pInfo = this.getDashboardWidgetsPlugins[i];
                                if(pInfo &&  Object.prototype.hasOwnProperty.call(pInfo,'pluginBundle') && pInfo.pluginBundle.js){
                                    if(pInfo && Object.prototype.hasOwnProperty.call(pInfo,"dependentPluginsToLoad")){
                                        if(Array.isArray(pInfo.dependentPluginsToLoad) && pInfo.dependentPluginsToLoad.length){
                                              for(let i = 0; i < pInfo.dependentPluginsToLoad.length; i++){
                                                 if(pInfo.dependentPluginsToLoad[i] && typeof pInfo.dependentPluginsToLoad[i] == 'function'){
                                                      pInfo.dependentPluginsToLoad[i](this);
                                                 }
                                                 if(typeof pInfo.dependentPluginsToLoad[i] == 'object' && pInfo.dependentPluginsToLoad[i].pluginBundle){
                                                      Utils.loadCssBundle(pInfo.dependentPluginsToLoad[i].pluginBundle.css);
                                                      Utils.loadPluginBundles([pInfo.dependentPluginsToLoad[i].pluginBundle.js],pInfo.dependentPluginsToLoad[i].componentLoadedEventName);
                                                 }
                                              }
                                        }
                                    }
                                    let respData = await Utils.loadPluginBundles([pInfo.pluginBundle.js],pInfo.componentLoadedEventName);
                                    if(respData && respData.length > 0){
                                        let pData = respData[0];
                                        console.log("pDatapData",pData)
                                        if(pData.pluginStore && Array.isArray(pData.pluginStore) && pData.pluginStore.length){
                                            for(let i = 0; i < pData.pluginStore.length; i++){
                                            if(!this.$store.hasModule(pData.pluginStore[i].module))
                                                this.$store.registerModule(pData.pluginStore[i].module,pData.pluginStore[i].store); // registers store dynamically at run time
                                            }
                                        }else{
                                        if(pData.pluginStore && !this.$store.hasModule(pData.pluginStore.module))
                                            this.$store.registerModule(pData.pluginStore.module,pData.pluginStore.store); // registers store dynamically at run time
                                        }
                                        Utils.loadCssBundle(pInfo.pluginBundle.css);
                                        this.registeredWidgetsData.push({
                                          component: pData.components,
                                          ...pInfo
                                        });
                                        console.log("this.registeredWidgetsDatathis.registeredWidgetsData",this.registeredWidgetsData)
                                    }
                                }
                            }
                        }catch(e){console.log(e)}
                    }
                }
        }
    },
    async created(){
        // this.listenMessagesFromChild(); //For OLDER approach
        this.getDashboardData(); 
        
        try{ //For newer approach
          for(let i = 0; i < this.getDashboardWidgetsPlugins.length; i++){
                let pInfo = this.getDashboardWidgetsPlugins[i];
                if(pInfo &&  Object.prototype.hasOwnProperty.call(pInfo,'pluginBundle') && pInfo.pluginBundle.js){
                  let respData = await Utils.loadPluginBundles([pInfo.pluginBundle.js],pInfo.componentLoadedEventName);
                  if(respData && respData.length > 0){
                    let pData = respData[0];
                    if(pData.pluginStore && Array.isArray(pData.pluginStore) && pData.pluginStore.length){
                        for(let i = 0; i < pData.pluginStore.length; i++){
                          if(!this.$store.hasModule(pData.pluginStore[i].module))
                            this.$store.registerModule(pData.pluginStore[i].module,pData.pluginStore[i].store); // registers store dynamically at run time
                        }
                    }else{
                      if(pData.pluginStore && !this.$store.hasModule(pData.pluginStore.module))
                          this.$store.registerModule(pData.pluginStore.module,pData.pluginStore.store); // registers store dynamically at run time
                    }
                    Utils.loadCssBundle(pInfo.pluginBundle.css);
                    this.registeredWidgetsData.push({
                      component: pData.components,
                      ...pInfo
                    });
                  }
                }
          }
        }catch(e){console.log(e)} 
    },
    beforeDestroy(){
        window.removeEventListener('message', this.manageDashboardWidgetsFunctionality);
        // this.removeWSEventListener({eventname:[NotifierConstants.workflowTaskRouteCreated,NotifierConstants.workflowTaskRouteUpdated,Constants.jobStatusUpdateNotification], callback:this.sendNotificationToChild, parent:"dashboard"});   //For OLDER approach 
    },
    mounted(){
        /* this.addWSEventListener({eventname:[NotifierConstants.workflowTaskRouteUpdated,NotifierConstants.workflowTaskRouteCreated,Constants.jobStatusUpdateNotification], callback:this.sendNotificationToChild, parent:"dashboard"}); //For OLDER approach
        setTimeout(() => { 
            this.registerInstalledWidgets();
            this.registeredWidgetsData = this.getRegisteredDashboardWidgets;
        }, 200); */

        this.registerInstalledWidgets(); //For newer approach
    }
})
</script>

<style lang="scss" scoped>
    $active-green-icon-color: #00ff3a;
    $count-bg-color:#e7c20b;
    $count-border-color:#373737;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $widgets-bg-color: #202729;

    .primary-btn-style{
        display: flex;
        align-items: self-start;
        justify-content: center !important;
        button{
            height: 38px;
            font-size:14px;
        }
        .text-light:hover{
            text-decoration: underline;
        }
    }
    
    .channel-create-icon{
        display: flex;
        justify-content: center;
        align-items: center;
        width: unset;
    }

    .icon-background-on-hover:hover{
        background: #d1d2d31a;
        fill: #eee !important;
    }

    .icon-background-on-hover{
        padding: 6px;
        height: 36px;
        width: 45px;
        border-radius: 4px;
        margin: 4px;
        background: #d1d2d31a;
    }

    .icon-on-hover-styles:hover{
        fill:#eee;
    }

    .widget-wrapper{
        display: grid;
        gap: 12px;
        grid-gap: 5px;
        grid-template-columns: 33% 33% 33%;
        padding: 10px;
        .widget-styles{
            // border:$border-color;
            background: #1b2122;
            border-radius: 5px;
            box-shadow: 0px 0px 9px 1px #141414;
            margin:5px;
            height:380px;
            position:relative;
        }
    }

    .storage-widget{
        grid-column: 2 / span 2;
    }

    @media only screen and (max-width: 600px) {
        .widget-wrapper {
            display: flex;
            flex-direction: column;        }
    }

    .outer {
        display: flex;
        height: 100%;
        width: 90%;
        justify-content: center;
        position: absolute;
        inset-inline-end: 0%;
        top:300px;
    }

    .middle {
        display: table-cell;
        vertical-align: middle;
    }

    .inner {
        margin-inline-start: auto;
        margin-inline-end: auto;
        width: 100%;
        height: 138px;
        margin-bottom:10%;
        /* Whatever width you want */
        img{
            height:100%;
        }
        p,div{
            text-align: center;
            color: #666;
            font-size: 20px;
            margin-bottom: 2px;
        }
    }

</style>